import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { BindContext } from "../BindQuote";
import useForm from "../../../hooks/useForm";
import GroupTravelHeading from "../../group_travel/components/Heading";
import { Accordion, AccordionSection } from "../../../components/interactives";
import BindQuoteStepNavigation from "../../group_travel/bind/BindQuoteStepNavigation";
import { termsConditionsValidations } from "../../../helpers/group_personal_accident/validations";
import ServerError from "../../errors/ServerError";
import AgreementSection from "../../../components/terms/AgreementSection";
import ImportantNoticesTerms from "../../group_travel/components/ImportantNoticesTerms";
import DeclarationTerms from "../../group_travel/components/DeclarationTerms";

type Props = {
  onSubmit: VoidFunction | null;
  onPrevious: VoidFunction | null;
};

const Terms: FC<Props> = ({ onSubmit, onPrevious }) => {
  const { state, onChange, isSubmitting, serverError, setServerError } = useContext(BindContext);
  const policyWordingUrl = "/documents/AU Group PA Policy Wording.pdf";
  const form = useForm(state, termsConditionsValidations, onChange);
  const { t } = useTranslation("pages", { keyPrefix: "groupTravel.newProduct.bind.terms" });
  const { t: tError } = useTranslation("pages", { keyPrefix: "groupTravel.newProduct.serverError" });
  const {
    field: { accepted, acceptedNotice },
  } = form;
  const handleNext = () => {
    onSubmit && form.validateForm(onSubmit);
  };
  return (
    <>
      <div className="container-flow flex-1">
        <GroupTravelHeading title={t("title")} alt="GroupPersonalAccident" />
        <Accordion omitMarginTop id="terms-info">
          {/* Important and declaration section */}
          <AccordionSection label="Important Notices" id="important-notices">
            <ImportantNoticesTerms />
          </AccordionSection>
          <AccordionSection label="Declaration" id="declaration">
            <DeclarationTerms productName="Group Personal Accident and Sickness" />
          </AccordionSection>
          <AgreementSection t={t} state={state} accepted={accepted} acceptedNotice={acceptedNotice} policyWordingUrl={policyWordingUrl} />
        </Accordion>
      </div>
      {serverError && (
        <ServerError displayType="modal" onClose={() => setServerError(false)} contactDetailsWithMailId={tError("contactDetailsWithMailId")} />
      )}
      <BindQuoteStepNavigation isLoading={isSubmitting} onBack={onPrevious} onSubmit={handleNext} nextButtonLabel="Submit" />
    </>
  );
};

export default Terms;
